import type { LatencyDistributionSpec } from '../model.js';

export const latencyGuidedTargets = {
  body: 'plot.marker.current.p50',
  tail: 'plot.marker.current.p95',
  comparison: 'plot.series.optimized',
} as const;

export function latencyDistributionFixture(
  width = 640,
  stress = false,
  focus: LatencyDistributionSpec['focus'] = 'overview',
  comparison = true,
): LatencyDistributionSpec {
  const current = stress
    ? [
        18, 20, 21, 22, 23, 24, 24, 25, 26, 26, 27, 28, 29, 30, 31, 31,
        32, 33, 34, 35, 36, 38, 40, 42, 45, 48, 52, 58, 65, 74, 86, 102,
        126, 158, 205, 280, 390, 540, 760, 1_280,
      ]
    : [
        18, 20, 21, 22, 23, 24, 24, 25, 25, 26, 27, 28, 28, 29, 30, 31,
        32, 33, 34, 35, 36, 38, 40, 42, 45, 48, 52, 58, 64, 72, 84, 98,
        116, 138, 164, 188,
      ];
  const optimized = stress
    ? [
        11, 12, 13, 13, 14, 14, 15, 15, 16, 16, 17, 17, 18, 18, 19, 20,
        21, 22, 23, 24, 25, 27, 30, 34, 38, 44, 51, 60, 72, 88, 108, 134,
        170, 220, 310, 430, 610, 840, 1_120, 1_460,
      ]
    : [
        11, 12, 13, 13, 14, 14, 15, 15, 16, 16, 17, 17, 18, 18, 19, 20,
        21, 22, 23, 24, 25, 27, 30, 34, 38, 44, 51, 60, 72, 88, 108, 134,
        170, 220, 310, 430,
      ];

  return {
    id: stress ? 'latency-distribution-stress' : comparison ? 'latency-distribution-comparison' : 'latency-distribution-single',
    family: 'latency-distribution',
    view: 'plot',
    viewport: { width, height: 470 },
    unit: 'ms',
    series: [
      {
        id: 'current',
        label: stress ? 'Current production release under an intentionally pathological long-tail workload' : 'Current release',
        samples: current,
      },
      ...(comparison
        ? [{
            id: 'optimized',
            label: stress ? 'Optimized candidate with a faster body but a stubbornly expensive extreme tail' : 'Optimized candidate',
            samples: optimized,
          }]
        : []),
    ],
    percentileMarkers: [50, 95, 99],
    focus,
    provenance: 'Deterministic request-latency fixture · empirical millisecond observations illustrating body, p95, p99, and long-tail behavior',
  };
}
